module.exports = __webpack_public_path__ + "img/icon-live.d9acf784.svg";